import React, { useEffect, useState } from 'react';
import { getAllTracks, uploadMediaReplace, getSettings, saveSettings } from './adminApi';
import './Admin.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const DEFAULT_FILES = {
	greeting: ['start1.mp3', 'start2.mp3', 'start3.mp3'],
	meditation: ['med1.mp3', 'med2.mp3', 'med3.mp3'],
	ending: ['end1.mp3', 'end2.mp3', 'end3.mp3'],
};

/** По 3 слота на категорию; имя файла берём из текущего списка с бэка или дефолт */
function getSlotsForTracks(tracks) {
	const sections = ['greeting', 'meditation', 'ending'];
	const sectionLabels = { greeting: 'Приветствие', meditation: 'Медитация', ending: 'Завершение' };
	const slots = [];
	sections.forEach((category) => {
		const list = tracks[category] || [];
		const defaults = DEFAULT_FILES[category];
		for (let i = 0; i < 3; i++) {
			const filename = list[i]?.name || defaults[i];
			slots.push({ category, filename, sectionLabel: sectionLabels[category] });
		}
	});
	return slots;
}

export default function Media() {
	const [tracks, setTracks] = useState({ greeting: [], meditation: [], ending: [] });
	const [loading, setLoading] = useState(true);
	const [confirmModal, setConfirmModal] = useState(null); // { slot, file, previewUrl, saving? }
	const [zoomLink, setZoomLink] = useState('');
	const [zoomMeetingId, setZoomMeetingId] = useState('');
	const [zoomPasscode, setZoomPasscode] = useState('');
	const [zoomLinkSaving, setZoomLinkSaving] = useState(false);

	useEffect(() => {
		getAllTracks()
			.then(setTracks)
			.catch((err) => {
				console.error('Ошибка загрузки медиа:', err);
			})
			.finally(() => setLoading(false));
	}, []);

	useEffect(() => {
		getSettings()
			.then((data) => {
				setZoomLink(data.zoomLink || '');
				setZoomMeetingId(data.meetingId || '');
				setZoomPasscode(data.passcode || '');
			})
			.catch((err) => console.error('Ошибка загрузки настроек:', err));
	}, []);

	// Освобождаем object URL при закрытии модалки
	useEffect(() => {
		return () => {
			if (confirmModal?.previewUrl) {
				URL.revokeObjectURL(confirmModal.previewUrl);
			}
		};
	}, [confirmModal]);

	const getUrlForSlot = (category, filename) => {
		const list = tracks[category] || [];
		const found = list.find((t) => t.name === filename);
		return found ? found.url : null;
	};

	const handleFileChange = (slot, e) => {
		const file = e.target.files?.[0];
		if (!file) return;
		const previewUrl = URL.createObjectURL(file);
		setConfirmModal({ slot, file, previewUrl });
		e.target.value = '';
	};

	const closeConfirmModal = () => {
		if (confirmModal?.previewUrl) {
			URL.revokeObjectURL(confirmModal.previewUrl);
		}
		setConfirmModal(null);
	};

	const handleConfirmSave = async () => {
		if (!confirmModal) return;
		const { slot, file } = confirmModal;
		setConfirmModal((prev) => (prev ? { ...prev, saving: true } : null));
		try {
			await uploadMediaReplace(slot.category, slot.filename, file);
			const updated = await getAllTracks();
			setTracks(updated);
			closeConfirmModal();
		} catch (err) {
			alert(err.message || 'Ошибка при замене файла');
			setConfirmModal((prev) => (prev ? { ...prev, saving: false } : null));
		}
	};

	const handleSaveZoomSettings = async () => {
		const link = zoomLink.trim();
		if (!link) {
			alert('Введите ссылку на Zoom');
			return;
		}
		setZoomLinkSaving(true);
		try {
			await saveSettings({
				zoomLink: link,
				zoomMeetingId: zoomMeetingId.trim(),
				zoomPasscode: zoomPasscode.trim(),
			});
			setZoomLink(link);
			setZoomMeetingId(zoomMeetingId.trim());
			setZoomPasscode(zoomPasscode.trim());
			alert('Настройки Zoom сохранены');
		} catch (err) {
			alert(err.message || 'Ошибка при сохранении');
		} finally {
			setZoomLinkSaving(false);
		}
	};

	if (loading) {
		return <div style={{ padding: 20 }}>Загрузка медиа…</div>;
	}

	const sections = ['greeting', 'meditation', 'ending'];
	const sectionTitles = { greeting: 'Приветствие', meditation: 'Медитация', ending: 'Завершение' };
	const allSlots = getSlotsForTracks(tracks);

	return (
		<div style={{ padding: '20px 0' }}>
			<h3>Медиа</h3>
			<p style={{ color: '#666', marginBottom: 20 }}>
				Замените аудиофайлы при необходимости. Имя файла на сервере сохраняется — логика презентации не меняется.
			</p>

			<div style={{ marginBottom: 32, padding: '16px', border: '1px solid #eee', borderRadius: 8, background: '#fafafa' }}>
				<h4 style={{ marginBottom: 12 }}>Настройки Zoom</h4>
				<p style={{ fontSize: 13, color: '#666', marginBottom: 10 }}>
					Используется в письмах при бронировании и в напоминании о сеансе.
				</p>
				<div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
					<div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10 }}>
						<label style={{ minWidth: 120 }}>Ссылка:</label>
						<input
							type="url"
							value={zoomLink}
							onChange={(e) => setZoomLink(e.target.value)}
							placeholder="https://us05web.zoom.us/j/..."
							style={{ flex: '1 1 300px', minWidth: 200, padding: '8px 12px', borderRadius: 5, border: '1px solid #ccc' }}
						/>
					</div>
					<div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10 }}>
						<label style={{ minWidth: 120 }}>Meeting ID:</label>
						<input
							type="text"
							value={zoomMeetingId}
							onChange={(e) => setZoomMeetingId(e.target.value)}
							placeholder="845 062 5388"
							style={{ flex: '1 1 200px', minWidth: 140, padding: '8px 12px', borderRadius: 5, border: '1px solid #ccc' }}
						/>
					</div>
					<div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10 }}>
						<label style={{ minWidth: 120 }}>Код доступа:</label>
						<input
							type="text"
							value={zoomPasscode}
							onChange={(e) => setZoomPasscode(e.target.value)}
							placeholder="t9H9BC"
							style={{ flex: '1 1 200px', minWidth: 140, padding: '8px 12px', borderRadius: 5, border: '1px solid #ccc' }}
						/>
					</div>
					<button
						type="button"
						className="btn_anketa"
						onClick={handleSaveZoomSettings}
						disabled={zoomLinkSaving}
						style={{ alignSelf: 'flex-start' }}
					>
						{zoomLinkSaving ? 'Сохранение…' : 'Сохранить'}
					</button>
				</div>
			</div>

			{sections.map((category) => (
				<div key={category} style={{ marginBottom: 32 }}>
					<h4 style={{ marginBottom: 12 }}>{sectionTitles[category]}</h4>
					<div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
						{allSlots.filter((s) => s.category === category).map((slot) => {
							const url = getUrlForSlot(slot.category, slot.filename);
							const key = `${slot.category}/${slot.filename}`;
							return (
								<div
									key={key}
									style={{
										display: 'flex',
										alignItems: 'center',
										gap: 16,
										flexWrap: 'wrap',
										padding: '12px',
										border: '1px solid #eee',
										borderRadius: 8,
										background: '#fafafa',
									}}
								>
									<div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 200 }}>
										<label style={{ fontWeight: 500 }}>{slot.filename}</label>
										<label style={{ cursor: 'pointer', fontSize: 12, color: '#48b8c7', textDecoration: 'underline' }}>
											Выбрать файл
											<input
												type="file"
												accept="audio/*"
												onChange={(e) => handleFileChange(slot, e)}
												style={{ display: 'none' }}
											/>
										</label>
									</div>
									{url && (
										<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
											<span style={{ fontSize: 18 }} title="Прослушать">🔊</span>
											<audio
												key={url}
												controls
												style={{ height: 32, maxWidth: 280 }}
												src={`${API_BASE_URL}${url}`}
											/>
										</div>
									)}
								</div>
							);
						})}
					</div>
				</div>
			))}

			{confirmModal && (
				<div className="modal-overlay" onClick={closeConfirmModal}>
					<div
						className="modal-content-media"
						onClick={(e) => e.stopPropagation()}
					>
						<h4 style={{ marginBottom: 16 }}>Подтверждение замены</h4>
						<p style={{ marginBottom: 12 }}>
							<strong>Файл:</strong> {confirmModal.file.name}
						</p>
						<p style={{ marginBottom: 12, fontSize: 13, color: '#666' }}>
							Будет сохранён как: {confirmModal.slot.filename}
						</p>
						<div style={{ marginBottom: 16 }}>
							<audio
								controls
								style={{ width: '100%', height: 36 }}
								src={confirmModal.previewUrl}
							/>
						</div>
						<div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
							<button
								type="button"
								className="btn_anketa"
								onClick={closeConfirmModal}
								disabled={confirmModal.saving}
								style={{ background: '#999' }}
							>
								Отмена
							</button>
							<button
								type="button"
								className="btn_anketa"
								onClick={handleConfirmSave}
								disabled={confirmModal.saving}
							>
								{confirmModal.saving ? 'Загрузка…' : 'Сохранить'}
							</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
